import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import DataTableExtensions from "react-data-table-component-extensions";
import DataTable from "react-data-table-component";
import Loader from "../../components/shared/Loader";
import { utils as XLSXUtils, writeFile } from "xlsx";
import { formatDate } from "../../helpers/functions";
import Papa from "papaparse";

const Table = ({ data, loading, handleDelete }) => {
	const [xlsxData, setXLSXData] = useState([]);

	useEffect(() => {
		// fetchMetaData();
		if (data?.length > 0)
			setXLSXData(
				data.map(user => {
					return {
						"تاريخ الانضمام": formatDate(new Date(user?.updated_at)),
						"اسم المستخدم": user?.studentName,
						"رقم الهاتف": user?.phone,
						"اسم المدرسة": user?.schoolName,
						المرحلة: user?.level,
					};
				})
			);
	}, [data]);

	const exportToXLSX = () => {
		const worksheet = XLSXUtils.json_to_sheet(xlsxData);
		const workbook = XLSXUtils.book_new();
		XLSXUtils.book_append_sheet(workbook, worksheet, "Sheet1");

		writeFile(workbook, `students-${formatDate(new Date())}.xlsx`);
	};

	const exportToCSV = () => {
		// Ensure data is an array of objects with keys representing column headers
		if (
			!Array.isArray(xlsxData) ||
			xlsxData.length === 0 ||
			typeof xlsxData[0] !== "object"
		) {
			console.error("Invalid data format for CSV export");
			return;
		}

		// Convert data to a CSV string
		const csv = Papa.unparse(xlsxData);

		// Create a Blob with the CSV data
		const blob = new Blob([csv], { type: "text/csv" });

		// Create a download link and trigger the download
		const link = document.createElement("a");
		link.href = URL.createObjectURL(blob);
		link.download = `students-${formatDate(new Date())}.xlsx`;
		link.click();
	};

	const columns = [
		{
			name: "اسم الطالب",
			selector: "studentName",
			sortable: true,
		},
		{
			name: "رقم الهاتف",
			selector: "phone",
			sortable: true,
		},
		{
			name: "اسم المدرسة",
			selector: "schoolName",
			sortable: true,
		},
		{
			name: "المرحلة",
			selector: "level",
			sortable: true,
		},
		{
			name: "الإجراءات",
			selector: "settings",
			cell: row => (
				<ul className="list-inline settingsList">
					<li className="list-inline-item">
						<Link
							className="bt bt-success bt-sm"
							to={`/students/show/${row.id}`}
						>
							<i className="fas fa-eye"></i>
						</Link>
					</li>
					<li className="list-inline-item">
						<button
							className="bt bt-danger bt-sm"
							onClick={() => handleDelete(row.id)}
						>
							<i className="fas fa-trash"></i>
						</button>
					</li>
				</ul>
			),
		},
	];

	return (
		<section>
			{loading && <Loader />}
			<div className="datatable">
				<div
					className="position-relative"
					style={{ marginBottom: "-0.5rem", zIndex: 1, height: 0 }}
				>
					<button className="btn btn-info" onClick={exportToXLSX}>
						<i className="fas fa-file-excel"></i> تحميل ملف
					</button>
					{/* <button className="btn btn-info" onClick={exportToCSV}>
						<i className="fas fa-file-csv"></i>
					</button> */}
				</div>
				<DataTableExtensions columns={columns} data={data}>
					<DataTable
						noHeader
						defaultSortField="id"
						defaultSortAsc={false}
						pagination
						highlightOnHover
						direction="rtl"
						striped
					/>
				</DataTableExtensions>
			</div>
		</section>
	);
};

export default Table;
